<template>
  <p class="octobus__label" v-if="label" v-html="$t('ticket.label', {label})"></p>
</template>

<script>
export default {
  name: 'Label',
  props: {
    label: {
      type: [String, Boolean],
    },
  },
};
</script>

<style lang="scss" scoped>
#app, #auth {
  .octobus__label {
    font-size: .85rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/Label.vue